import { Injectable } from '@angular/core';

@Injectable()
export class CommonValidationService {
  private separators: string[] = [' ', '\\\@'];

  constructor() { }

  public getIdentifierPattern() {
    return /^[A-Za-z_][A-Za-z0-9_]*$/;
  }

  public getEmailPattern() {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  }

  private validGuidRegex() {
    return /^(\{{0,1}([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}\}{0,1})$/;
  }

  public failedPasswordVailidationMessage() {
    let message: string = 'Password must be greater than 8 characters. \nRequires at least 1 upper and lower case character. ';
    message = message + '\nRequires at least 1 numeric and special character. \nShould not have blank or empty spaces. \nShould not contain your username or a part of it. \r\n';
    return message;
  }

  public validateGuid(guid: string): boolean {
    return (guid.length > 0 && guid.trim() && this.validGuidRegex().test(guid.trim()));
  }

  public validateIdentifier(identifier: string): boolean {
    return (identifier.length > 0 &&
      identifier.trim() &&
      identifier.search(this.getIdentifierPattern()) !== -1);
  }

  public validateEmail(email: string): boolean {
    return (email.length > 0 &&
      email.trim() &&
      this.getEmailPattern().test(email));
  }

  public validatePassword(password: string, username: string): boolean {
    if (password.length <=8) {
      return false;
    }
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumberCase = /[0-9]/.test(password);
    const hasSpecialCharacterCase = /[\W]/.test(password);
    const hasNoBlankSpaceCase = /^$|\s+/.test(password);
    const hasUsernameInPassword = this.passwordContainsUsername(password, username);

    if (hasUpperCase && hasLowerCase && hasSpecialCharacterCase && hasNumberCase && !hasNoBlankSpaceCase && !hasUsernameInPassword) {
      return true;
    }

    return false;
  }

  private passwordContainsUsername(password: string, username: string): boolean {
    let result: boolean = false;
    const usernameParts: string[] = username.toLowerCase().split(new RegExp(this.separators.join('|'), 'g'));
    password = password.toLowerCase();

    usernameParts.forEach(namePart => {
      if (password.includes(namePart)) {
        result = true;
      }
    });

    return result;
  }

}
